export default __webpack_public_path__ + "static/media/stepbar_1.7ca644e6.png";